<div v-if="item" class="tt-o-byline tt-u-spacing--left--xs">
  <!--<a v-if="item.user" href="" class="tt-o-byline__item tt-o-byline__action" @click.prevent="selectedAuthor" rel="nofollow">{{formatUserName(item.user)}}</a>-->
  <span v-if="item.user" class="tt-o-byline__item tt-o-byline__author">{{formatUserName(item.user)}}</span>
  <span v-else class="tt-o-byline__item" v-html="$msg('byline.anon')"></span>
  <tt-badge v-if="item.expertLabel" type="expert" v-html="item.expertLabel"></tt-badge>
  <tt-badge v-else-if="item.isIndependentExpert" type="expert" v-html="$msg('badge.expert')"></tt-badge>
  <tt-badge v-else-if="item.isStaff" type="staff" v-html="$msg('badge.staff')"></tt-badge>
  <span class="tt-o-byline__dot"></span>
  <time :datetime="item.dateCreated" class="tt-o-byline__item tt-o-byline__on-date">{{item.dateCreatedFormatted}}</time>
  <span v-if="purchasedText" class="tt-o-byline__dot"></span>
  <time v-if="purchasedText" class="tt-o-byline__item tt-o-byline__purchased" :datetime="purchasedDatetime" v-html="purchasedText"></time>
  <span v-if="syndicationText" class="tt-o-byline__dot"></span>
  <span v-if="syndicationText" class="tt-o-byline__item tt-o-byline__syndication-source" v-html="syndicationText"></span>
  <template v-for="menuItem in menuItems" :key="menuItem.name + '-byline'">
    <span class="tt-o-byline__dot"></span>
    <tt-button type="link"
               :class="['tt-o-byline__options-item--' + menuItem.name]"
               class="tt-o-byline__item tt-o-byline__action tt-o-byline__options-item"
               @click.prevent="menuItemSelected(menuItem)"
               :aria-controls="menuItem.cntrlsId"
               :aria-expanded="menuItem.expanded"
               :aria-disabled="menuItem.disabled ? 'true' : null"
               :disabledClassOnly="menuItem.disabled"
               v-html="menuItem.title"></tt-button>
  </template>
  <tt-menu v-if="menuItems" :tiggerAriaLabel="$msg('byline.optionsMenu')" triggerClass="tt-o-byline__menu-trigger" triggerType="icon">
    <template v-slot:triggerContent><tt-icon name="more-h" size="sm"></tt-icon></template>
    <tt-menu-list class="tt-o-byline__menu-list" :menuItems="menuItems" @menuItemSelected="menuItemSelected"></tt-menu-list>
  </tt-menu>
</div>
